export default {
  'Address.detail.gotoLocation': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'location',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Address.detail.saveEdit': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'save_edit',
    },
  },
  'Address.detail.saveNew': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'add_save',
    },
  },
  'Address.detail.defaultEdit': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'default_edit',
    },
  },
  'Address.detail.delete': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'addr_del',
    },
  },
  'Address.detail.recognizeClear': {
    operation: ['touch'],
    c: {
      type: 'constant',
      value: 'addr_recognize_clear',
    },
  },
  'Address.detail.recognizeRecog': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'addr_recognize_recog',
    },
  },
  'Address.detail.deleteConfirm': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'addrdel_pop_confirm',
    },
  },
  'Address.detail.deleteCancel': {
    operation: ['touch'],
    c: {
      type: 'constant',
      value: 'addrdel_pop_cancel',
    },
  },
  'Address.detail.relocate': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'relocate',
    },
  },
  'Address.detail.history': {
    operation: ['visible', 'touch'],
    c: {
      type: 'constant',
      value: 'history_addr',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.index + 1;
      },
    },
  },
  'Address.detail.regionList': {
    operation: ['visible'],
    getParse: {
      type: 'variable',
      func(item, data, { pageName }) {
        return [
          {
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            d: item.index + 1,
            c: 'select_addr',
          },
        ];
      },
    },
  },
  'Address.detail.regionItem': {
    operation: ['touch'],
    c: {
      type: 'constant',
      value: 'select_addr',
    },
    d: {
      type: 'variable',
      func: function getD(traceData) {
        return traceData.index + 1;
      },
    },
  },
  'Address.detail.addAddr': {
    operation: ['TOUCH', 'visible'],
    c: {
      type: 'constant',
      value: 'add_addr',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 地址弹窗-地址选择
  'Address.common.addrChoice': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'addr_choice',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  // 地址弹窗-地址编辑
  'Address.common.editAddr': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'edit_addr',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid({ url }) {
        return 'u=' + url || '';
      },
    },
  },
  // 地址弹窗-去新建地址
  'Address.common.addAddr': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'add_addr',
    },
    d: {
      type: 'constant',
      value: '1',
    },
    iid: {
      type: 'variable',
      func: function getIid({ url }) {
        return 'u=' + url || '';
      },
    },
  },
  'Address.map.searchListItem': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'map_search_list',
    },
    d: {
      type: 'variable',
      func({ index }) {
        return index + 1;
      },
    },
  },
  'Address.map.searchList': {
    operation: ['VISIBLE'],
    getParse: {
      type: 'variable',
      func(item, data, { pageName }) {
        if (item.index === 0) {
          return {
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            d: item.index + 1,
            c: 'map_search_list',
          };
        }
      },
    },
  },
  'Address.lightingexpress.searchList': {
    operation: ['VISIBLE'],
    // c: {
    //   type: 'constant',
    //   value: 'searchlist',
    // },

    getParse: {
      type: 'variable',
      func(item, data, { pageName }) {
        if (item.index === 0) {
          return {
            item: item.item,
            isViewable: item.isViewable,
            key: item.key,
            index: item.index,
            page: pageName,
            b: pageName,
            d: item.index + 1,
            c: 'position_searchlist',
          };
        }
      },
    },
  },
  'Address.lightingexpress.searchItem': {
    operation: ['TOUCH'],
    c: {
      type: 'constant',
      value: 'position_searchlist',
    },
    d: {
      type: 'variable',
      func({ index }) {
        return index + 1;
      },
    },
  },
  'Address.lightingexpress.header': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'position_search',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
  'Address.lightingexpress.relocate': {
    operation: ['TOUCH', 'VISIBLE'],
    c: {
      type: 'constant',
      value: 'position_local',
    },
    d: {
      type: 'constant',
      value: '1',
    },
  },
};
